module.exports = __webpack_public_path__ + "img/vue1-milieu_rouge.b72e0df5.png";